import { useState } from 'react';
import { Link } from 'react-router-dom';
import { authAPI } from '../api/client';
import { useTranslation } from 'react-i18next';

export default function ForgotPassword() {
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');
    setLoading(true);
    try {
      const r = await authAPI.forgotPassword(email);
      setMessage(r.data?.message || t('forgot.emailSentFallback'));
    } catch (err) {
      setError(err.response?.data?.detail || t('common.error'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={S.page}>
      <div style={S.hexBg} />
      <div style={S.card}>
        <div style={{ textAlign: 'center', marginBottom: 28 }}>
          <span style={{ fontSize: 40, display: 'block', marginBottom: 8 }}>🍯</span>
          <h1 style={{ fontSize: 24, fontFamily: "'DM Sans', sans-serif", fontWeight: 700, color: '#2C1A0E' }}>
            {t('forgot.title')}
          </h1>
          <p style={{ fontSize: 13, color: '#8B6355', marginTop: 6 }}>
            {t('forgot.subtitle')}
          </p>
        </div>

        {message ? (
          <div style={S.success}>{message}</div>
        ) : (
          <form onSubmit={submit}>
            <div className="form-group">
              <label className="form-label">{t('login.emailLabel')}</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="form-input"
                placeholder={t('login.emailPlaceholder')}
                required
              />
            </div>
            {error && <div style={S.error}>{error}</div>}
            <button
              type="submit"
              className="btn btn-primary"
              style={{ width: '100%', justifyContent: 'center', padding: 12 }}
              disabled={loading}
            >
              {loading ? '...' : t('forgot.sendBtn')}
            </button>
          </form>
        )}

        <div style={{ textAlign: 'center', marginTop: 20 }}>
          <Link to="/login" style={S.link}>{t('common.back')}</Link>
        </div>
      </div>
    </div>
  );
}

const S = {
  page: { minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20, background: 'linear-gradient(135deg, #FDF0DC 0%, #F5C47A 50%, #E8922A 100%)', position: 'relative' },
  hexBg: { position: 'absolute', inset: 0, opacity: 0.06, backgroundImage: "url(\"data:image/svg+xml,%3Csvg width='60' height='52' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M30 0 L60 17.3 L60 34.6 L30 52 L0 34.6 L0 17.3Z' fill='%232C1A0E'/%3E%3C/svg%3E\")", backgroundSize: '60px 52px' },
  card: { background: 'rgba(255,252,248,0.96)', backdropFilter: 'blur(12px)', borderRadius: 24, padding: 40, width: '100%', maxWidth: 400, boxShadow: '0 20px 60px rgba(44,26,14,0.2)', position: 'relative', zIndex: 1 },
  error: { background: '#FDECEA', color: '#C0392B', padding: '10px 14px', borderRadius: 8, fontSize: 13, marginBottom: 12 },
  success: { background: '#E8F5E9', color: '#2E7D32', padding: '14px 16px', borderRadius: 10, fontSize: 14, lineHeight: 1.5, textAlign: 'center' },
  link: { color: '#8B6355', fontSize: 13, textDecoration: 'none' },
};
